import h from 'hyperscript';

import enrichmentIcon from '@disy/cadenza-icons/enrich.svg';
import { icon } from '@disy/ui/icon';
import { createLabelWithIcon } from '@disy/ui/label-with-icon';

import { createResourceLabel } from 'ui/resource-label/resource-label';

import type { AttributeTileAttribute } from 'cadenza/ui/attribute-tile/attribute-tile-attribute';
import type { WorkbookAttributeDto } from 'cadenza/workbook/api/workbook-attribute-dto';

import i18n from './attribute-formatting-utils.properties';

interface NamedAttribute {
  printName: string;
}

export function attributePrintName(attribute: NamedAttribute) {
  return attribute.printName ?? i18n('attribute.unknown.name');
}

export type AttributeWithObjecttype = Pick<
  WorkbookAttributeDto,
  'fromCombinedObjecttype' | 'objecttypePrintName' | 'enrichedObjecttypePrintName'
>;

export function attributeObjecttypeLabel(attribute: AttributeWithObjecttype): HTMLElement {
  const resourceType = attribute.fromCombinedObjecttype ? 'combinedObjecttype' : 'objecttype';

  if (attribute.enrichedObjecttypePrintName) {
    const enrichmentFor = createLabelWithIcon(icon(enrichmentIcon), i18n('enrichment.label'));
    const attributeLabel = createResourceLabel('objecttype', attribute.enrichedObjecttypePrintName);
    return h('div', [enrichmentFor, attributeLabel]);
  } else {
    return createResourceLabel(resourceType, attribute.objecttypePrintName);
  }
}

export function hierarchyLevelDetails({
  levels = [],
  selectedLevelName,
}: AttributeTileAttribute): (Element | string)[] {
  return levels
    .map(({ name, printName }) => (name === selectedLevelName ? h('strong', printName) : printName))
    .flatMap((level, i) => (i ? [', ', level] : [level]));
}
